import * as models from 'smg/customer-api/models';
import * as session from 'smg/customer-api/session';
import * as shippingoptions from 'smg/customer-api/shippingoptions';
import * as phone from 'smg/phone';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import { PageLoader } from '../account';
import { AccountReady } from '../account-session';
import * as address from '../address';
import { CheckPOBoxAddress, PromptNew } from '../shippingoptions';

void main();

async function main() {
    if (await AccountReady) {
        return;
    }

    const user = await session.Session().then(s => s.user);

    const addNewTemplate = document.querySelector('#addNewTemplate') as HTMLElement;
    const parent = document.querySelector('#shippingAdressesContainer') as HTMLElement;
    const addNewButton = document.querySelectorAll('.addNew');
    const cardTemplate = document.querySelector('#cards') as HTMLTemplateElement;

    addNewButton.forEach(el => {
        el.addEventListener('click', async () => {
            await PromptNew(user).then(() => {
                pl.load();
            });
        });
    });

    const pl: PageLoader<models.ShippingOption> = new PageLoader<models.ShippingOption>({
        afterLoad: () => {
            parent.append(addNewTemplate);
            addNewTemplate.classList.remove('d-none');
        },
        parent: document.querySelector('#shippingAdressesContainer') as HTMLElement,
        get: () => shippingoptions.ShippingOptions({
            sort: pl.sort() ?? '',
            max: String(pl.currentPageSize()),
            p: String(pl.currentPage()),
            q: pl.search(),
            'data': 'id,label,address',
        }).then(({ shippingOptions, nextPage }) => ({ rows: shippingOptions, nextPage })),
        draw: async shippingOption => {
            const card = template.Clone(cardTemplate).firstElementChild as HTMLElement;
            const shippingAddress = shippingOption.address;
            if (!shippingAddress) {
                return card;
            }
            const addressEl = address.Draw(shippingAddress);
            const addressParent = card.querySelector<HTMLElement>('.address');

            addressParent?.appendChild(addressEl);

            // Checkout drops options whose stored phone fails the server tel validator; let the customer fix it here.
            if (!phone.IsValid(shippingAddress.phoneNumber?.phone ?? '')) {
                addressParent?.appendChild(phone.InvalidPhoneNote());
            }

            // Grab user details
            const user = await session.Session().then(s => s.user);
            const editBtn = card.querySelector('.edit-bt') as HTMLButtonElement;
            const deleteBtn = card.querySelector('.delete-btn') as HTMLButtonElement;

            editBtn?.addEventListener('click', () => {
                void PromptNew(user, shippingOption).then(() => {
                    pl.load();
                });
            });

            deleteBtn?.addEventListener('click', () => {
                void shippingoptions.DeleteShippingOption(shippingOption.id).then(() => {
                    card.parentElement?.removeChild(card);
                    toast.Undo('Removed shipping option.', async () => {
                        await shippingoptions.RestoreShippingOption(shippingOption.id);
                        pl.load();
                    });
                    pl.load();
                });
            });
            void CheckPOBoxAddress(shippingAddress.countryID || 0, shippingAddress.stateID || 0, shippingAddress.addressLine1 || '', addressParent as HTMLElement);
            return card;
        },

    });

    parent?.previousElementSibling?.classList.add('d-none');

    pl.load();
}
